import { IconProps } from './IconProps';

export const UhxInfoWeightLoss = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5962 17.7091C17.7165 17.2351 18.5732 16.6494 19.1416 15.9873C18.5665 18.2167 14.8832 20.7277 10.0351 21.9996L9.23043 18.9324C9.37138 18.9351 9.51313 18.937 9.65523 18.937C12.2597 18.937 14.7247 18.5009 16.5962 17.7091Z"
        fill="black"
      />
      <path
        d="M18.2234 10.6714V12.1172L17.5444 12.5339V11.1177C17.0185 11.4169 16.392 11.682 15.689 11.9072V14.3427L14.806 14.5512V12.1587C14.316 12.2808 13.7976 12.3851 13.2552 12.4681V13.6467L12.3717 13.7531V12.5805C11.8451 12.6368 11.3022 12.6757 10.744 12.6918V15.1761H9.86023V12.6977C9.19398 12.6904 8.54614 12.6536 7.92226 12.5902V13.7531L7.03849 13.6467V12.4824C6.40524 12.3888 5.80579 12.2654 5.24386 12.1187V14.5512L4.3608 14.2365V11.8584C3.7587 11.6574 3.2166 11.4257 2.74957 11.1684V12.5339L2.07097 12.1172V10.7392C1.28995 10.1667 0.841309 9.50365 0.841309 8.7959V13.9186C0.841309 14.255 0.942565 14.5818 1.13241 14.8934C2.15912 16.5785 5.78479 17.8238 10.1007 17.8238C10.3393 17.8238 10.5748 17.8187 10.8089 17.8111C15.5915 17.6585 19.3601 15.9745 19.3601 13.9186V8.7959C19.3601 9.47559 18.9474 10.1147 18.2234 10.6714Z"
        fill="black"
      />
      <mask
        id="mask0_1511_1203"
        style={{ maskType: 'alpha' } as React.CSSProperties}
        maskUnits="userSpaceOnUse"
        x="1"
        y="-1"
        width="18"
        height="14"
      >
        <path
          d="M18.8974 8.79543C18.8974 10.7131 15.011 12.2677 10.2168 12.2677C5.42259 12.2677 1.53613 10.7131 1.53613 8.79543C1.53613 7.70156 1.53613 -0.000976562 1.53613 -0.000976562C1.53613 -0.000976562 8.15726 -0.000976562 10.2168 -0.000976562C12.3301 -0.000976562 18.8974 -0.000976562 18.8974 -0.000976562C18.8974 -0.000976562 18.8974 7.72307 18.8974 8.79543Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1511_1203)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.27869 3.46587L6.98125 4.16842L4.5637 6.58597L3.91455 5.93682C2.36708 8.64014 2.74758 12.1465 5.05602 14.4549C7.82005 17.2189 12.3014 17.2189 15.0654 14.4549C17.8295 11.6909 17.8295 7.20951 15.0654 4.44548C12.6797 2.05977 9.01463 1.73324 6.27869 3.46587ZM4.03299 15.4779C0.703965 12.1489 0.703965 6.75148 4.03299 3.42246C7.36202 0.0934279 12.7594 0.0934279 16.0885 3.42246C19.4175 6.75148 19.4175 12.1489 16.0885 15.4779C12.7594 18.807 7.36202 18.807 4.03299 15.4779Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.06865 15.3871C2.41557 13.734 1.59516 11.559 1.60844 9.39547C1.61851 7.75445 2.49018 6.47691 3.31004 5.65706L6.21828 2.74881C7.03814 1.92896 8.31567 1.05729 9.9567 1.04722C12.1202 1.03394 14.2953 1.85434 15.9483 3.50742C19.2288 6.78791 19.2288 12.1066 15.9483 15.3871C12.6679 18.6676 7.34913 18.6676 4.06865 15.3871ZM3.77857 9.40879C3.78379 8.5569 4.24219 7.79399 4.84458 7.1916L7.75282 4.28335C8.35521 3.68096 9.11812 3.22257 9.97002 3.21734C11.5772 3.20747 13.1875 3.81568 14.4138 5.04196C16.8468 7.47494 16.8468 11.4196 14.4138 13.8526C11.9808 16.2856 8.03617 16.2856 5.60319 13.8526C4.37691 12.6263 3.7687 11.016 3.77857 9.40879Z"
          fill="black"
          fillOpacity="0.5"
        />
      </g>
    </svg>
  );
};

